module.exports = __webpack_public_path__ + "img/error.8c3376d3.png";